import Vue from 'vue'
import VueRouter from 'vue-router'
import { isMobile } from '../utils/device'
import mobileRoutes from './mobile'

// 桌面端路由
import Home from '../views/Home.vue'
import About from '../views/About.vue'
import Services from '../views/Services.vue'
import Cases from '../views/Cases.vue'
import Partners from '../views/Partners.vue'
import Contact from '../views/Contact.vue'
import CaseDetail from '../views/CaseDetail.vue'
import NewsDetail from '../views/NewsDetail.vue'

Vue.use(VueRouter)

const desktopRoutes = [
    {
        path: '/',
        name: 'Home',
        component: Home,
        meta: {
            title: '四川庚源电力科技有限公司 - 首页'
        }
    },
    {
        path: '/about',
        name: 'About',
        component: About,
        meta: {
            title: '关于我们 - 四川庚源电力科技有限公司'
        }
    },
    {
        path: '/services',
        name: 'Services',
        component: Services,
        meta: {
            title: '业务范围 - 四川庚源电力科技有限公司'
        }
    },
    {
        path: '/cases',
        name: 'Cases',
        component: Cases,
        meta: {
            title: '成功案例 - 四川庚源电力科技有限公司'
        }
    },
    {
        path: '/cases/:id',
        name: 'CaseDetail',
        component: CaseDetail,
        meta: {
            title: '案例详情 - 四川庚源电力科技有限公司'
        }
    },
    {
        path: '/partners',
        name: 'Partners',
        component: Partners,
        meta: {
            title: '合作伙伴 - 四川庚源电力科技有限公司'
        }
    },
    {
        path: '/contact',
        name: 'Contact',
        component: Contact,
        meta: {
            title: '联系我们 - 四川庚源电力科技有限公司'
        }
    },
    {
        path: '/news/:id',
        name: 'NewsDetail',
        component: NewsDetail,
        meta: {
            title: '新闻详情 - 四川庚源电力科技有限公司'
        }
    },
    {
        path: '*',
        redirect: '/'
    }
]

// 根据设备类型选择路由
const routes = isMobile() ? mobileRoutes : desktopRoutes

const router = new VueRouter({
    mode: 'history',
    base: process.env.BASE_URL,
    routes,
    // 修改为（删除未使用的参数）
    scrollBehavior() {
        return { x: 0, y: 0 }
    }
})

// 路由守卫设置页面标题
router.beforeEach((to, from, next) => {
    if (to.meta.title) {
        document.title = to.meta.title
    }
    next()
})

export default router
